import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Domains from "@/views/Domains.vue";
import Login from "@/views/Login.vue";

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  { path: '/', name: 'Domains', meta: {auth: true}, component: Domains},
  { path: '/login', name: 'Login', meta: {auth: false}, component: Login},
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
    const data: any = localStorage.getItem('session')
    const session: any = JSON.parse(data)
    if (to.matched.some(record => record.meta.auth) && session == null){
        next({
            name: "Login",
            path: "/login"
        });
    } else {
        next()
    }
})

export default router
